module.exports = __webpack_public_path__ + "img/arrow-left-down.551cf76d.svg";